export default "__VITE_ASSET__9ef01cc0__"